import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { Form, Row, Col, Button, Divider, Table } from '_zari/core'
import { ZariContext } from '_zari/context'

import { TiposDocumentoSunatConstant, CodigosTransaccionesConstant } from 'constants/index'

import * as FacturacionService from 'services/facturacion.service'
import * as GuiasVentaService from 'services/guiasVenta.service'
import * as Modals from './modals'

import * as FormGroups from './formGroups'

import { ValidationSchema } from './validation'

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const modalDataRef = React.useRef({})

  const [flagClienteSeleccionado, setFlagClienteSeleccionado] = React.useState(false)
  const [flagDocumentoSeleccionado, setFlagDocumentoSeleccionado] = React.useState(false)
  const [flagEditable, setFlagEditable] = React.useState(false)
  const [documentosData, setDocumentosData] = React.useState([])
  const [filas, setFilas] = React.useState([])
  const [detalles, setDetalles] = React.useState([])
  const [mostrarModalResumen, setMostrarModalResumen] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      _idDireccion: '',
      _idDocumentoRelacionado: '',
      _idPlaca: '',
      _idSocio: '',
      documentoSocio: '',
      fechaEmision: '',
      fechaInicio: '',
      codigoMotivo: '',
      modalidad: '',
      nombreSocio: '',
      numeroDocumento: '',
      numeroBultos: '',
      numeroContenedor: '',
      flagTransbordo: false,
      flagMostrarSoloCerradas: false,
      pesoBrutoTotal: '',
      serieDocumento: '',
      tipoDocumento: TiposDocumentoSunatConstant.OTROS,
      tipoDocumentoSocio: '',
      _idConductor: ''
    }
  }, [])

  const rowHeaders = React.useMemo(() => {
    return [
      { label: 'FECHA', width: 80 },
      { label: 'TIPO', width: 60 },
      { label: 'SERIE', width: 60 },
      { label: 'FACTURA', width: 90 },
      { label: 'N. GUIA', width: 80 },
      { label: 'CODIGO', width: 90 },
      { label: 'PRODUCTO' },
      { label: 'UNIDAD', width: 70 },
      { label: 'FACTURADA', width: 100 },
      { label: 'ENTREGADA', width: 100 },
      { label: 'DEVUELTA', width: 100 },
      { label: 'X ENTREGAR', width: 100 },
      { label: 'SALIDA', width: 80 }
    ]
  }, [])

  const onChangeCantidad = React.useCallback((e, { _idProducto, _idProductoPresentacion, cantidadxEntregar }) => {
    const nuevoValor = e.target.value
    setDetalles(prev => {
      const newOut = [...prev]

      const found = newOut.find(x => x._idProducto === _idProducto && x._idProductoPresentacion === _idProductoPresentacion)

      if (found) {
        found.cantidad = nuevoValor
      } else {
        newOut.push({
          _idProducto: _idProducto,
          _idProductoPresentacion: _idProductoPresentacion,
          cantidad: nuevoValor,
          cantidadxEntregar: cantidadxEntregar
        })
      }

      return newOut
    })
  }, [])

  const rowTemplate = React.useCallback(
    (row, key) => {
      if (!row.fechaEmision) {
        return (
          <Table.Row key={key}>
            <Table.Cell colSpan={13}>&emsp;</Table.Cell>
          </Table.Row>
        )
      } else {
        return (
          <Table.Row key={key}>
            <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.tipoDocumento || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.numeroGuia || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.codigoProducto || '--'}</Table.Cell>
            <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.unidadMedida || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.cantidadFacturada || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.cantidadEntregada || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.cantidadDevuelta || '--'}</Table.Cell>
            <Table.Cell align='center'>{row.cantidadxEntregar || '--'}</Table.Cell>
            {row.flagUltimo && row.cantidadxEntregar > 0 ? (
              <Table.Cell align='center'>
                <Form.InputText
                  key={`${key}-nuevaCantidad`}
                  id={`${key}-nuevaCantidad`}
                  name={`${key}-nuevaCantidad`}
                  onChange={e => onChangeCantidad(e, row)}
                  value={
                    detalles.some(x => x._idProducto === row._idProducto && x._idProductoPresentacion === row._idProductoPresentacion)
                      ? detalles.find(x => x._idProducto === row._idProducto && x._idProductoPresentacion === row._idProductoPresentacion).cantidad
                      : ''
                  }
                />
              </Table.Cell>
            ) : (
              <Table.Cell align='center'>{'--'}</Table.Cell>
            )}
          </Table.Row>
        )
      }
    },
    [onChangeCantidad, detalles]
  )

  const clickBuscarDocumentos = React.useCallback(
    (idSocio, flagMostrarSoloCerradas) => {
      if (!idSocio) {
        __zariContext.snack('error', 'Seleccionar cliente')
        return
      }

      FacturacionService.obtenerSinEntregaxIdSocioAsSelect(idSocio, flagMostrarSoloCerradas).then(({ data }) => {
        setDocumentosData(data)
        setFlagClienteSeleccionado(true)
      })
    },
    [__zariContext]
  )

  const clickSeleccionarDocumento = React.useCallback(
    idDocumento => {
      if (!idDocumento) {
        __zariContext.snack('error', 'Seleccionar documento')
      }

      FacturacionService.obtenerxIdAsInfoSinEntrega(idDocumento).then(({ data }) => {
        setFlagEditable(data.flagEditable)
        setFilas(data.filas)
      })
      setFlagDocumentoSeleccionado(true)
    },
    [__zariContext]
  )

  const submitHandler = (data, { setSubmitting }) => {
    for (let i = 0; i < detalles.length; i++) {
      const det = detalles[i]

      if (det.cantidad) {
        if (parseFloat(det.cantidad) > parseFloat(det.cantidadxEntregar)) {
          __zariContext.snack('error', 'Verificar cantidades ingresadas.')
          return
        }
      }
    }

    const detallesNormalizados = detalles
      .filter(x => x.cantidad)
      .map(x => {
        return {
          _idProductoPresentacion: x._idProductoPresentacion,
          cantidad: parseFloat(x.cantidad)
        }
      })

    GuiasVentaService.nuevaGuia({
      ...data,
      detalles: detallesNormalizados
    })
      .then(() => {
        __zariContext.snack('success', 'El registro se ha agregado.')
        history.push(`/${CodigosTransaccionesConstant.VENTASINGRESOGUIA_LISTA}`)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
        setSubmitting(false)
      })
  }

  const clickMostrarResumen = React.useCallback(
    values => {
      modalDataRef.current = { ...values, detalles: detalles.filter(x => x.flagUltimo && x.cantidadxEntregar > 0) }

      setMostrarModalResumen(true)
    },
    [detalles]
  )

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, touched, values, setValues, isSubmitting, setFieldValue, handleSubmit }) => (
          <Form>
            <Row>
              <Col md={8}>
                <Row>
                  <Col md={8}>
                    <FormGroups.ClienteFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idSocio}
                      values={values}
                      setValues={setValues}
                      iValue={values._idSocio}
                    />
                  </Col>
                  {!flagClienteSeleccionado && (
                    <>
                      <Col md={2}>
                        <FormGroups.FlagMostrarSoloCerradasFormGroup fIsSubmitting={isSubmitting} iValue={values.flagMostrarSoloCerradas} />
                      </Col>
                      <Col md={2}>
                        <Button
                          onClick={() => clickBuscarDocumentos(values._idSocio, values.flagMostrarSoloCerradas)}
                          disabled={flagClienteSeleccionado}
                          tiny
                          block
                        >
                          Buscar Documentos
                        </Button>
                      </Col>
                    </>
                  )}
                </Row>
                {flagClienteSeleccionado && (
                  <>
                    <Row>
                      <Col md={8}>
                        <FormGroups.DocumentosFormGroup
                          documentosData={documentosData}
                          fIsSubmitting={isSubmitting}
                          iError={errors._idDocumentoRelacionado}
                          iTouched={touched._idDocumentoRelacionado}
                          flagDocumentoSeleccionado={flagDocumentoSeleccionado}
                        />
                      </Col>
                      {!flagDocumentoSeleccionado && (
                        <Col md={2}>
                          <Button
                            onClick={() => clickSeleccionarDocumento(values._idDocumentoRelacionado)}
                            disabled={flagDocumentoSeleccionado}
                            tiny
                            block
                          >
                            Seleccionar
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </>
                )}
              </Col>
            </Row>
            {flagDocumentoSeleccionado && (
              <>
                <Divider />
                <Row>
                  <Col md={12}>
                    <Table maxRowsShown={10} filas={filas} headRows={rowHeaders} rowTemplate={rowTemplate} />
                  </Col>
                </Row>
                <Divider />
              </>
            )}
            <Row>
              <Col md={12}>
                {flagDocumentoSeleccionado && !flagEditable && (
                  <>
                    <Row>
                      <Col md={3}>
                        <FormGroups.TipoDocumentoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.tipoDocumento}
                          iTouched={touched.tipoDocumento}
                        />
                        <FormGroups.SerieNumeroFormGroup
                          fIsSubmitting={isSubmitting}
                          setFieldValue={setFieldValue}
                          tipoDocumentoValue={values.tipoDocumento}
                        />
                        <FormGroups.FechaEmisionFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaEmision} iTouched={touched.fechaEmision} />
                        <FormGroups.FechaInicioFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaInicio} iTouched={touched.fechaInicio} />
                      </Col>
                      <Col md={3}>
                        <FormGroups.MotivoFormGroup fIsSubmitting={isSubmitting} iError={errors.codigoMotivo} iTouched={touched.codigoMotivo} />
                        <FormGroups.ConductorFormGroup fIsSubmitting={isSubmitting} iError={errors._idConductor} iTouched={touched._idConductor} />
                        <FormGroups.PlacaFormGroup fIsSubmitting={isSubmitting} iError={errors._idPlaca} iTouched={touched._idPlaca} />
                        <FormGroups.ModalidadFormGroup fIsSubmitting={isSubmitting} iError={errors.modalidad} iTouched={touched.modalidad} />
                        <FormGroups.PesoBrutoTotalFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.pesoBrutoTotal}
                          iTouched={touched.pesoBrutoTotal}
                        />
                      </Col>
                      <Col md={4}>
                        <FormGroups.DireccionSocioFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors._idDireccion}
                          iTouched={touched._idDireccion}
                          setFieldValue={setFieldValue}
                          vIdSocio={values._idSocio}
                        />
                        <FormGroups.NumeroBultosFormGroup fIsSubmitting={isSubmitting} iError={errors.numeroBultos} iTouched={touched.numeroBultos} />
                        <FormGroups.NumeroContenedorFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.numeroContenedor}
                          iTouched={touched.numeroContenedor}
                        />
                        <Row>
                          <Col md={12}>
                            <Row>
                              <Col md={4}>
                                <FormGroups.FlagTransbordoFormGroup fIsSubmitting={isSubmitting} iValue={values.flagTransbordo} />
                              </Col>
                              <Col md={8}>
                                <Button disabled={isSubmitting} onClick={() => clickMostrarResumen(values)}>
                                  Ver Resumen
                                </Button>
                                <Button onClick={handleSubmit} tiny block>
                                  Guardar
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      {mostrarModalResumen && (
        <Modals.ResumenModal show={mostrarModalResumen} handleClose={() => setMostrarModalResumen(false)} modalData={modalDataRef.current} />
      )}
    </>
  )
}

export default React.memo(MainForm)
